import {
    _axios as request
} from "../../plugins/axios";

//信息队列部分的操作
const actions = {
    //获取一次消息
    handleReceive(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/rabbit/receive',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    //清空消息队列
    handleClearMQ(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/rabbit/clear',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

export default {
    namespaced:true,
    actions,
}
